var a = Object.defineProperty;
var u = (r, e, t) => e in r ? a(r, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[e] = t;
var n = (r, e, t) => (u(r, typeof e != "symbol" ? e + "" : e, t), t), c = (r, e, t) => {
  if (!e.has(r))
    throw TypeError("Cannot " + t);
};
var l = (r, e, t) => (c(r, e, "read from private field"), t ? t.call(r) : e.get(r)), p = (r, e, t) => {
  if (e.has(r))
    throw TypeError("Cannot add the same private member more than once");
  e instanceof WeakSet ? e.add(r) : e.set(r, t);
}, f = (r, e, t, i) => (c(r, e, "write to private field"), i ? i.call(r, t) : e.set(r, t), t);
var s;
class h {
  constructor({ stringifyValue: e = !0 }) {
    n(this, "_meter");
    p(this, s, void 0);
    f(this, s, e);
  }
  setMeter(e) {
    this._meter = e;
  }
  processEvents(e) {
    let t = e;
    return l(this, s) && (t = this.stringifyObjectValues(t)), t = this.replacingDot(t), t;
  }
  // Преобразует значения свойств объекта в строку
  stringifyObjectValues(e) {
    for (let t in e)
      e.hasOwnProperty(t) && (typeof e[t] == "object" ? this.stringifyObjectValues(e[t]) : e[t] = String(e[t]));
    return e;
  }
  // Заменяет . в названия ключей на _
  replacingDot(e) {
    for (let t in e)
      if (e.hasOwnProperty(t)) {
        if (typeof e[t] == "object")
          this.replacingDot(e[t]);
        else if (t.includes(".")) {
          const i = t.replace(/\./g, "_");
          e[i] = e[t], delete e[t];
        }
      }
    return e;
  }
}
s = new WeakMap();
export {
  h as P
};
